/**
 * O'rnatish taklifini USHLAB QOLISH.
 *
 * NEGA ALOHIDA MODUL. `beforeinstallprompt` sahifa yuklanishining boshida,
 * bir marta ishga tushadi. Ilgari uni `InstallPrompt.vue` tinglardi, u esa
 * `MainLayout` ichida edi — ya'ni tinglovchi faqat foydalanuvchi TIZIMGA
 * KIRGANIDAN keyin ulanardi. Sayt esa `/login` bilan ochiladi va hodisa
 * o'sha yerda, hech kim tinglamayotgan paytda o'tib ketardi. Natijada
 * taklif hech qachon chiqmasdi.
 *
 * Shuning uchun tinglovchi shu modul IMPORT QILINGANDA — Vue mount
 * bo'lishidan oldin — ulanadi va hodisa saqlanib turadi. Komponent
 * keyinroq paydo bo'lsa ham, tayyor turgan taklifni oladi.
 */

import { ref } from 'vue'

const DISMISS_KEY = 'pwa-install-dismissed'

// Ushlangan hodisa. Komponent buni kuzatib turadi.
export const canInstall = ref(false)
export const isInstalled = ref(false)

let deferred = null

export function isIosDevice() {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream
}

export function isStandalone() {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
}

export function wasDismissed() {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1'
  } catch (e) {
    // Shaxsiy rejimda localStorage xato tashlashi mumkin — taklifni
    // ko'rsatavergan ma'qul.
    return false
  }
}

export function rememberDismissed() {
  try {
    localStorage.setItem(DISMISS_KEY, '1')
  } catch (e) { /* esda qolmaydi, zarari yo'q */ }
}

/** Brauzerning o'rnatish oynasini ochadi. `true` — taklif ko'rsatildi. */
export async function promptInstall() {
  if (!deferred) return false
  const e = deferred
  deferred = null
  canInstall.value = false
  e.prompt()
  try {
    await e.userChoice
  } catch (err) { /* foydalanuvchi oynani yopdi */ }
  return true
}

export function initPwa() {
  if (typeof window === 'undefined') return

  isInstalled.value = isStandalone()

  window.addEventListener('beforeinstallprompt', (e) => {
    // Brauzerning o'z taklifini to'xtatamiz — o'rniga o'zimiznikini
    // kerakli vaqtda va ilova uslubida ko'rsatamiz.
    e.preventDefault()
    deferred = e
    canInstall.value = true
  })

  window.addEventListener('appinstalled', () => {
    deferred = null
    canInstall.value = false
    isInstalled.value = true
  })
}
